import { ActionBase } from '@/models/action_base';
import { KbnConst } from '@/utils/kbn';

import { useActionDataClear } from './use_action_data_clear';
import { useActionOpenExternalXShare } from './use_action_open_external_x_share';
import { useFileUpload } from './use_file_upload';
import { useInsertDataStore } from './use_insert_data_store';
import { usePopupDialog } from './use_popup_dialog';

/**
 * カスタマイズアクション
 */
export class ActionCustomizing extends ActionBase {
  typeKbn = KbnConst.ACTION_TYPE_KBN_CUSTOMIZING;

  keyName?: string;

  use() {
    const popup = usePopupDialog();
    const fileUpload = useFileUpload();
    const { purchaseCount } = useInsertDataStore();
    if (this.keyName === 'data_clear') {
      return useActionDataClear();
    }
    if (this.keyName === 'validate') {
      return async () => {
        let isValid = false;
        for (let i = 4; i <= 200; i++) {
          if (purchaseCount.value === i.toString()) {
            isValid = true;
          }
        }
        if (!isValid) {
          await popup.alert('購入本数を入力してください。');
          return true;
        }
        if (!fileUpload.fileCache.value) {
          await popup.alert('レシート画像をアップロードしてください。');
          return true;
        }
        return false;
      };
    }
    if (this.keyName === 'x_share') {
      return useActionOpenExternalXShare();
    }

    // コース情報が選択される箇所に設定する
    // 末尾がコース ID とした key をカスタムアクションとして設定する
    if (this.keyName && this.keyName.startsWith('course_id_save_')) {
      const insertDataStore = useInsertDataStore();
      return async () => {
        if (this.keyName) {
          const courseId = this.keyName.slice('course_id_save_'.length);
          insertDataStore.courseId.value = courseId;
        }
        return false;
      };
    }
    return async () => await execute(this.keyName);
  }

  constructor(init: Partial<ActionCustomizing> = {}) {
    super();
    Object.assign(this, init);
  }
}

async function execute(
  keyName: string | undefined,
) {
  // キー名を使って好きな処理を実行できる
  alert(`このアクションは未実装（キー名: ${ keyName }）`);
  return false;
}

export function generateActionCustomizing(keyName?: string): ActionCustomizing {
  return new ActionCustomizing({
    keyName,
  });
}
